import React from 'react';
import Button from '../../../components/Button';
import {
	TemplateBoolean,
	TemplateDate,
} from '../../../components/Attributes/Attributes_old';
import { MinusCircleIcon } from '@heroicons/react/24/outline';
import Attributes from '../../../components/Attributes';
import classNames from 'classnames';

const SERVICE_MODULE_ID = process.env.REACT_APP_MODULE_ID_SERVICE;
const EVENT_MODULE_ID = process.env.REACT_APP_MODULE_ID_EVENT;

const ScheduleStepTask = ({
	moduleFieldsBreakdown,
	skipModuleKeys,
	updatedForm,
	setUpdateForm,
	form,
}) => {
	console.log('moduleFieldsBreakdown: ', moduleFieldsBreakdown);
	const EVENT_STATUS_FIELD_ID = moduleFieldsBreakdown?.event?.find(
		(o) => o.key === 'defaultEventStatus' && o.isDefault
	)?.id;

	return (
		<>
			{moduleFieldsBreakdown?.event
				?.filter((field) => skipModuleKeys.indexOf(field.key) === -1)
				?.sort((a, b) => {
					return a?.order - b?.order;
				})
				?.map((field) => (
					<>
						<Attributes
							field={field}
							onChange={(index, value, fullValue) => {
								if (value || fullValue) {
									let updatedValue = form[index]?.value;

									if (fullValue) {
										updatedValue = fullValue;
									} else {
										if (updatedValue && Array.isArray(value)) {
											updatedValue = [
												...(Array.isArray(updatedValue)
													? updatedValue
													: [updatedValue]),
												...value,
											];
										} else {
											updatedValue = value;
										}
									}

									setUpdateForm({
										...updatedForm,
										[index]: {
											value: updatedValue,
											fieldId: field.id,
										},
									});
								} else {
									let updated = { ...updatedForm };
									updated[index] = {
										...updated[index],
										value: null,
									};

									setUpdateForm(updated);
								}
							}}
							form={{ ...form, ...updatedForm }}
							updatedForm={updatedForm}
							setForm={setUpdateForm}
							moduleId={SERVICE_MODULE_ID}
						/>
					</>
				))}

			{updatedForm?.occurrences?.value === 'custom' &&
			updatedForm?.occurrences?.dates?.length
				? updatedForm?.occurrences?.dates
						?.sort((a, b) => a.getTime() - b.getTime())
						.map((date, dateIdx) => (
							<>
								<div className="col-span-1 flex col-start-1">
									<div className="flex-1">
										<TemplateDate
											value={date}
											minDate={updatedForm?.serviceStart?.value}
											onChange={(index, newDate) => {
												let oldDates = updatedForm?.occurrences?.dates;
												oldDates[dateIdx] = newDate;
												setUpdateForm({
													...updatedForm,
													occurrences: {
														...updatedForm?.occurrences,
														dates: oldDates,
													},
												});
											}}
										/>
									</div>
									<div className="flex-shrink flex items-center pt-1.5 ml-3">
										<MinusCircleIcon
											className="w-6 h-6 cursor-pointer text-gray-500"
											onClick={() => {
												setUpdateForm({
													...updatedForm,
													occurrences: {
														...updatedForm?.occurrences,
														dates: updatedForm?.occurrences?.dates?.filter(
															(d, dIdx) => dIdx !== dateIdx
														),
													},
												});
											}}
										/>
									</div>
								</div>
							</>
						))
				: null}

			<div
				className={classNames(
					'col-span-2 flex',
					updatedForm?.occurrences?.value === 'custom'
						? 'justify-between'
						: 'justify-start'
				)}
			>
				<TemplateBoolean
					name="Scheduled dates"
					onChange={(index, value) => {
						console.log('change: ', value);
						setUpdateForm({
							...updatedForm,
							defaultEventStatus: {
								value: value ? 'scheduled' : 'estimated',
								fieldId: EVENT_STATUS_FIELD_ID,
							},
						});
					}}
					value={updatedForm?.defaultEventStatus?.value === 'scheduled'}
				/>
				{updatedForm?.occurrences?.value === 'custom' && (
					<Button
						type="secondary"
						onClick={() =>
							setUpdateForm({
								...updatedForm,
								occurrences: {
									...updatedForm?.occurrences,
									dates: [
										...(updatedForm?.occurrences?.dates || []),
										moment().toDate(),
									],
								},
							})
						}
					>
						Add date
					</Button>
				)}
			</div>
		</>
	);
};

export default ScheduleStepTask;
